// extracted by mini-css-extract-plugin
module.exports = {"column-role":"TeamTable_column-role__Sn_L9"};